import ApiBase from './Api'
import { NewsItem } from 'types/NewsItem'

const NEWS_API_PATHS = {
    NEWS: '/news',
}

class NewsApi extends ApiBase {
    async findAll(): Promise<NewsItem[]> {
        const response = await this._getRequest(NEWS_API_PATHS.NEWS)

        return response
    }
}

export default NewsApi
